const disableScroll = (e) => {
  e.target.blur();
};

const handleFocus = (input) => {
  input.addEventListener('wheel', disableScroll);
};

document.querySelectorAll('input[type="number"]').forEach(input => {
  input.addEventListener('focus', () => handleFocus(input));
});
